


















































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { membershipCategoryFields } from '@/config/subscriptions';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import moment from 'moment';

@Component({
  name: 'bpc-membership-category-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
  },
})
export default class MembershipCategoryForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: MembershipCategory;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: MembershipCategory;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  // DATA

  dataLoaded: boolean = false;

  // COMPUTED

  get formModel(): MembershipCategory {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }
  get membershipCategoryId(): string | number {
    return this.formModel?.id || this.$route.params?.id || null;
  }

  get fieldsConfig() {
    return membershipCategoryFields;
  }

  get price(): number {
    return this.formModel?.price || 225;
  }
  get fixed_start_date(): string {
    return this.formModel?.fixed_start_date;
  }
  get fixed_end_date(): string {
    return this.formModel?.fixed_end_date;
  }
  get period(): string {
    let period = '';
    const start = this.fixed_start_date ? moment(this.fixed_start_date).format('DD/MM/YYYY') : '';
    const end = this.fixed_end_date ? moment(this.fixed_end_date).format('DD/MM/YYYY') : '';
    if (start && end) {
      period = `${start} - ${end}`;
    } else if (start) {
      period = `From ${end}`;
    } else if (end) {
      period = `Until ${end}`;
    }
    return period;
  }

  get membershipCategoryFilters() {
    return [
      {
        filterField: 'subscription_category_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }
  get paymentFilters() {
    return [
      {
        filterField: 'subscription_category_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }
  get messageTableFilters() {
    return [
      {
        filterField: 'related_entity_name',
        value: 'subscription_category',
      },
      {
        filterField: 'related_entity_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 px-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 px-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 px-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 px-2': true,
        },
      },
    };
  }

  // public formModel: MembershipCategory = null;

  // LIFECYCLE
  // created(){}
  // updated(){}
  // destroyed(){}

  // METHODS
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  onChangePeriod(period) {
    this.formModel.period_id = period?.id || null;
    if (period && period.start_date) {
      this.formModel.fixed_start_date = period.start_date;
    }
    if (period && period.end_date) {
      this.formModel.fixed_end_date = period.end_date;
    }
  }
  // WATCHERS
}
